import { Link as ChakraLink, LinkProps } from '@chakra-ui/react';
import { FC } from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';

import { fontWeights } from '../global/Fonts';

export const Link: FC<LinkProps & RouterLinkProps> = (props) => {
  return <ChakraLink color="accent" fontWeight={fontWeights.bold} as={RouterLink} {...props} />;
};

export default Link;
